<template>
  <div>
    <naj-confirmation
      :title="local.caseRelatedRequest.reconsiderationFromNonCaseParty.addJudgementTextForObjectionBtn"
      :show-modal="judgementObjectionTextModal"
      :max-width="1000"
      :is-persistent="true"
      :ok-btn-label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.accept"
      :close-btn-label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.cancel"
      @cancel="closeJudgementObjectionTextModal"
      @ok="addRequestSubject"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.judgementSectionLabel"
              :items="judgementCorrectionSections"
              :value.sync="subjectDetails.judgementCategory"
              item-text="name"
              item-value="id"
              :disabled="isViewMode"
              validates="required"
              @change="getJudgementSection"
            ></naj-input>
          </v-col>
        </v-row>
        <v-row v-if="judgementSectionText && !loading">
          <v-col>
            <span>
              {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.judgementSectionText }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              v-if="loading"
              class="loader-holder"
            >
              <naj-loader></naj-loader>
            </div>
            <div
              v-if="judgementSectionText && !loading"
              class="scrollable-div"
            >
              <p
                ref="content"
                @mouseup="highlightSelectedText"
                v-html="judgementSectionText"
              />
            </div>
          </v-col>
        </v-row>
        <v-row
          v-if="judgementSectionText && !loading"
          class="note-container"
        >
          <v-col>
            <span class="sub-note">
              {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.highlightNote }}
            </span>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>

    <naj-box :title="local.caseRelatedRequest.reconsiderationFromNonCaseParty.objectionJudgementText">
      <div v-if="isViewMode">
        <naj-no-data
          :has-data="formModel.requestSubjects && formModel.requestSubjects.length > 0"
          :loading="loading"
          :no-data-message="local.common.selectBoxNoData"
        ></naj-no-data>
      </div>
      <div
        v-for="(requestSubject,index) in formModel.requestSubjects"
        :key="index"
      >
        <v-row>
          <v-col cols="10">
            <label class="section-title">{{ requestSubject.judgementSectionName }}</label>
          </v-col>
          <v-col cols="2">
            <v-btn
              v-if="!isViewMode"
              icon
              @click="editSubject(index)"
            >
              <v-icon color="primary">
                mdi-lead-pencil
              </v-icon>
            </v-btn>
            <v-btn
              v-if="!isViewMode"
              icon
              @click="selectSubjectToDelete(index) "
            >
              <v-icon color="red">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="requestSubject.judgementHighlightedText"
            cols="6"
          >
            <naj-input
              disabled
              :type-id="formFieldType.textarea"
              :label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.judgementSectionText"
              :value.sync="requestSubject.judgementHighlightedText"
              validates="required|max:2800|allowed_special_character"
              rows="5"
            ></naj-input>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="!isViewMode">
        <v-col cols="9">
          <span>
            {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.addJudgementTextForObjection }}
          </span>
        </v-col>
        <v-col cols="3">
          <naj-button
            :disabled="formModel.requestSubjects && formModel.requestSubjects.length >= 5"
            @click="showJudgementObjectionTextModal()"
          >
            {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.addJudgementTextForObjectionBtn }}
          </naj-button>
        </v-col>
      </v-row>
    </naj-box>

    <naj-box :title="local.caseRelatedRequest.reconsiderationFromNonCaseParty.argumentAndExecution">
      <v-row>
        <v-col cols="12">
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.argumentBody"
            :value.sync="formModel.argument"
            :maxlength="200"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col cols="12">
          <naj-input
            :label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.stopExecution"
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.stopExecution"
            :items="yesOrNo"
            item-text="name"
            item-value="id"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.stopExecution == 0"
          cols="12"
        >
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.caseRelatedRequest.reconsiderationFromNonCaseParty.stopExecutionNotes"
            :value.sync="formModel.stopExecutionNotes"
            :maxlength="200"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-confirmation
      :show-modal="showDeleteSubjectConfirmationModal"
      :title="local.caseRelatedRequest.reconsiderationFromNonCaseParty.accept"
      :message="local.caseRelatedRequest.reconsiderationFromNonCaseParty.warningTextDelete"
      :ok-btn-label="local.common.yes"
      :close-btn-label="local.common.no"
      @ok="() => {
        showDeleteSubjectConfirmationModal = false;
        removeSubject();
      }"
      @cancel="showDeleteSubjectConfirmationModal = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import { socialIdentityTypeEnum, countriesEnum, judgementSection } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('LawsuitModule');

const initSubjectDetails = () => ({
  judgementCategory: Object,
  subjectIndex: Object,
  judgementHighlightedText: null,
});
export default {
  name: 'ReconsiderationFromNonCaseParty',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
    viewMode: {
      type: Boolean,
      required: true,
      default: () => false,
    },

  },
  data() {
    return {
      loading: false,
      judgments: [],
      selectedJudgment: {},
      judgementObjectionTextModal: false,
      subjectDetails: initSubjectDetails(),
      activeJudgement: '',
      subjectFile: [],
      showDeleteSubjectConfirmationModal: false,
      selectedSubject: 0,
      editedSubject: -1,
      judgementSectionTextResult: null,
      startIndex: 0,
      endIndex: 0,
      judgementSectionText: '',
      judgementSectionTexts: [],

    };
  },
  computed: {
    ...mapLUTState(['judgementCorrectionSections', 'yesOrNo']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.viewMode;
    },
  },
  watch: {},
  mounted() {
    if (this.formModel.case && this.formModel.case.judgmentCode) {
      this.setSelectedJudgment();
    }

    if (!this.isViewMode)
      this.$set(this.formModel, 'requestSubjects', []);
    this.readCurrentUserInfo();
    this.subjectDetails = initSubjectDetails();
    this.subjectFile = [];
  },
  created() {
  },
  methods: {
    ...mapActions([
      'getJudgementSections',
    ]),

    getJudgementSection(value) {
      if (this.judgementSectionTextResult && this.judgementSectionTextResult.judgementCode == this.selectedJudgment.judgementCode) {
        if (this.subjectDetails.judgementCategory == judgementSection.waqae)
          this.judgementSectionText = this.judgementSectionTextResult.waqae;
        else if (this.subjectDetails.judgementCategory == judgementSection.reasons)
          this.judgementSectionText = this.judgementSectionTextResult.reasons;
        else if (this.subjectDetails.judgementCategory == judgementSection.mantoq)
          this.judgementSectionText = this.judgementSectionTextResult.mantoq;
      }
      else {
        this.loading = true;
        const params = {
          judgementCode: this.selectedJudgment.judgmentCode,
          caseCode: this.formModel.case.caseCode,
        };
        this.getJudgementSections(params)
          .then((res) => {
            this.judgementSectionTextResult = res;
            this.$set(this.judgementSectionTextResult, 'judgementCode', this.selectedJudgment.judgementCode);
            this.getJudgementSection();
          })
          .finally(
            () => (this.loading = false
            )
          );
      }
    },

    removeSubject() {
      this.formModel.requestSubjects.splice(this.selectedSubject, 1);
      this.judgementSectionTexts.splice(this.selectedSubject, 1);
    },

    editSubject(index) {
      this.editedSubject = index;
      this.subjectDetails = initSubjectDetails();
      this.subjectDetails.judgementCategory = this.formModel.requestSubjects[index].judgementSectionId;
      this.subjectDetails.judgementHighlightedText = this.formModel.requestSubjects[index].judgementHighlightedText;
      this.subjectDetails.judgementSectionText = this.judgementSectionTexts[index];
      this.startIndex = this.formModel.requestSubjects[index].startIndex;
      this.endIndex = this.formModel.requestSubjects[index].endIndex;
      this.judgementSectionText = this.judgementSectionTexts[index];
      this.$nextTick(() => {
        this.highlightByIndex(this.formModel.requestSubjects[index].startIndex, this.formModel.requestSubjects[index].endIndex);
      });

      this.judgementObjectionTextModal = true;
    },

    selectSubjectToDelete(index) {
      this.selectedSubject = index;
      this.showDeleteSubjectConfirmationModal = true;
    },

    setSelectedJudgment() {
      this.$set(this.selectedJudgment, 'judgmentCode', this.formModel.case.judgmentCode);
      this.activeJudgement = this.formModel.case.judgmentCode;
    },
    showJudgementObjectionTextModal() {
      this.editedSubject = -1;
      this.subjectDetails = initSubjectDetails();
      this.judgementSectionText = '';

      if (this.selectedJudgment.judgmentCode === undefined) {
        this.toaster.error(this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.selectJudgementErrorMsg);
      }
      else {
        document.body.style.userSelect = 'none';
        this.judgementObjectionTextModal = true;
      }
    },
    closeJudgementObjectionTextModal() {
      document.body.style.userSelect = '';
      this.judgementObjectionTextModal = false;
    },
    highlightSelectedText() {
      const selection = window.getSelection();
      const selectedText = selection.toString();
      if (!this.normalizeArabic(this.judgementSectionText).includes(this.normalizeArabic(selectedText))) {
        this.clearHighlights();
        this.toaster.error(this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.selectValidTextErrorMsg);
        return;
      }
      // ensure some text is selected
      if (!selectedText) return;
      const content = this.$refs.content;
      // find the start and end positions
      let startOffset = 0;
      let endOffset = 0;
      let charCount = 0;

      const range = selection.getRangeAt(0);
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      // traverse text nodes to find exact start and end indices
      while (walker.nextNode()) {
        const node = walker.currentNode;
        // if the range starts in this node
        if (node === range.startContainer) {
          startOffset = charCount + range.startOffset;
        }
        // if the range ends in this node
        if (node === range.endContainer) {
          endOffset = charCount + range.endOffset;
          break;
        }
        charCount += node.textContent.length;
      }
      this.startIndex = startOffset;
      this.endIndex = endOffset;
      this.subjectDetails.judgementHighlightedText = selectedText;
      // highlight the text using the range API
      this.applyHighlight(range);
      // clear the selection
      selection.removeAllRanges();
    },
    highlightByIndex(startIndex, endIndex) {
      this.clearHighlightsOfEdit();
      const content = this.$refs.content;
      const text = content.textContent;

      // validate indices
      if (
        startIndex < 0 ||
        endIndex > text.length ||
        startIndex >= endIndex
      ) {
        alert('Invalid indices. Please enter valid start and end indices.');
        return;
      }

      // clear previous highlights
      this.clearHighlightsOfEdit();

      // create a Range object
      const range = document.createRange();

      let charCount = 0;
      let startNode = null;
      let endNode = null;
      let startOffset = 0;
      let endOffset = 0;

      // find the correct nodes and offsets for the indices
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      while (walker.nextNode()) {
        const node = walker.currentNode;
        const nodeLength = node.textContent.length;

        // determine start node and offset
        if (!startNode && charCount + nodeLength >= startIndex) {
          startNode = node;
          startOffset = startIndex - charCount;
        }

        // determine end node and offset
        if (!endNode && charCount + nodeLength >= endIndex) {
          endNode = node;
          endOffset = endIndex - charCount;
          break;
        }

        charCount += nodeLength;
      }

      // set the range to highlight the text
      if (startNode && endNode) {
        range.setStart(startNode, startOffset);
        range.setEnd(endNode, endOffset);

        // wrap the range in a <span> for highlighting
        const span = document.createElement('span');
        span.style.backgroundColor = 'cyan';
        range.surroundContents(span);
      }
    },

    clearHighlightsOfEdit() {
      const content = this.$refs.content;

      // remove all <span> elements but keep their text
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_ELEMENT,
        null,
        false
      );

      const spans = [];
      while (walker.nextNode()) {
        if (walker.currentNode.tagName === 'SPAN') {
          spans.push(walker.currentNode);
        }
      }

      spans.forEach((span) => {
        const parent = span.parentNode;
        while (span.firstChild) {
          parent.insertBefore(span.firstChild, span);
        }
        parent.removeChild(span);
      });
    },

    applyHighlight(range) {
      // clear previous highlights
      this.clearHighlights();
      // wrap the selected text in a span with a yellow background
      const highlightSpan = document.createElement('span');
      highlightSpan.style.backgroundColor = 'cyan';
      highlightSpan.textContent = range.toString();
      range.deleteContents(); // remove selected text
      range.insertNode(highlightSpan); // insert highlighted text
    },

    clearHighlights() {
      const content = this.$refs.content;

      // traverse and replace all spans with their plain text content
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_ELEMENT,
        null,
        false
      );

      const spans = [];
      while (walker.nextNode()) {
        if (walker.currentNode.tagName === 'SPAN') {
          spans.push(walker.currentNode);
        }
      }

      spans.forEach((span) => {
        const parent = span.parentNode;
        while (span.firstChild) {
          parent.insertBefore(span.firstChild, span);
        }
        parent.removeChild(span);
      });
    },

    addRequestSubject() {
      if (!this.judgementSectionText) {
        this.toaster.error(this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.addJudgementSectionTextErrorMsg);
      }
      else if (!this.subjectDetails.judgementHighlightedText) {
        this.toaster.error(this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.selectJudgementTextErrorMsg);
      }
      else {
        var modifiedSubject = {
          judgementSectionId: this.subjectDetails.judgementCategory,
          judgementSectionName: this.judgementCorrectionSections.find(e => e.id == this.subjectDetails.judgementCategory).name,
          judgementHighlightedText: this.subjectDetails.judgementHighlightedText,
          startIndex: this.startIndex,
          endIndex: this.endIndex,
        };

        if (this.editedSubject > -1) {
          this.formModel.requestSubjects[this.editedSubject] = modifiedSubject;
          this.judgementSectionTexts[this.editedSubject] = this.judgementSectionText;
        }
        else {
          this.formModel.requestSubjects.push(modifiedSubject);
          this.judgementSectionTexts.push(this.judgementSectionText);
        }
        //this.formModel.requestSubjects = this.requestSubjects;
        this.closeJudgementObjectionTextModal();
      }
    },
    submitData() {
      if (this.subjectDetails && this.subjectDetails.length > 0) {
        this.$refs.requestFormRef.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.submitRequestForm();
              this.closeAddDataModal();
            }
          });
      }
    },
    readCurrentUserInfo() {

      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
    normalizeArabic(str) {
      return str
        // Remove diacritics
        .replace(/[\u064B-\u0652\u0670\u0640]/g, '')
        // Normalize different forms of Alef
        .replace(/[إأآا]/g, 'ا')
        // Normalize Teh Marbuta and Heh
        .replace(/ة/g, 'ه')
        // Normalize different forms of Yeh
        .replace(/ي/g, 'ى')
        // Remove extra spaces
        .replace(/\s+/g, ' ')
        .trim();
    },
  },
};
</script>

                 <style lang="scss" scoped>
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}

span {
  font-size: 22px;
}

.section-title {
  font-size: 22px;
  color: var(--app-primary-color);
}
.attachment-name {
  font-size: 18px;
}
.download-attachment {
  margin-right: 10px;
}
p {
  user-select: text;
  display: block;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #e9e9e9;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
}
.scrollable-div {
  overflow-y: auto;
  max-height: 200px;
}
.subject-attachment {
  display: flex;

  .subject-confirm-text {
    margin-left: 10px;
  }

  .uplaod-attachments-button .img-actions {
    width: 100% !important;
  }
}
.sub-note {
  font-size: 14px;
  color: var(--app-secondary-color);
}

.note-container {
  margin-top: -12px;
}
</style>
